import { Component, ViewChild, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { SecurityService } from '../security.service';
import { SnackService } from '../../shared-services/snack.service';
import { FormValidatorService } from '../../shared-services/form-validator.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  @ViewChild('form') public userForm: NgForm;

  credentials = { email: '', password: '' };
  isLoading = false;
  redirectUrl = 'home';

  constructor(
    private formValidatorService: FormValidatorService,
    private router: Router,
    private securityService: SecurityService,
    private snackService: SnackService,
  ) { }

  ngOnInit() {
  }

  async login() {
    if (this.validateForm()) {
      this.invokeLogin();
    }
  }

  validateForm() {
    return this.formValidatorService.isFormValid(this.userForm);
  }

  async invokeLogin() {
    try {
      this.isLoading = true;
      await this.securityService.login(this.credentials);
      await this.router.navigateByUrl(this.redirectUrl);
    } catch (error) {
      this.isLoading = false;
      this.snackService.error('Usuario o contraseña inválidos');
    }
  }



}



// WEBPACK FOOTER //
// ./src/app/security/login/login.component.ts